import { v4 as uuidv4 } from 'uuid'
import { t } from 'ttag'

export const getColumns = () => [
  { header: t`candidate`, accessorKey: 'name', alignLeft: true },
  { header: t`phone` },
  { header: t`language` },
  { header: t`invited`, accessorKey: 'invited' },
  { header: t`deadline` },
  { header: t`progress`, accessorKey: 'status' },
  { header: '', id: uuidv4() },
]
